import { render, staticRenderFns } from "./ActivitiesGroups.vue?vue&type=template&id=4aac1a0c"
import script from "./ActivitiesGroups.vue?vue&type=script&lang=js"
export * from "./ActivitiesGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports